export const marketplaceTranslations = {
  en: {
    'marketplace.title': 'Marketplace',
    'marketplace.subtitle': 'Discover local businesses near you',
    'marketplace.filters.title': 'Filters',
    'marketplace.filters.category': 'Category',
    'marketplace.filters.allCategories': 'All Categories',
    'marketplace.filters.locationRadius': 'Location Radius',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Worldwide',
    'marketplace.filters.clear': 'Clear Filters',
    'marketplace.categories.ecommerce': 'E-Commerce',
    'marketplace.categories.food_beverage': 'Food & Beverage',
    'marketplace.categories.retail': 'Retail',
    'marketplace.categories.services': 'Services',
    'marketplace.categories.digital': 'Digital',
    'marketplace.categories.clothing': 'Clothing',
    'marketplace.categories.electronics': 'Electronics',
    'marketplace.categories.books': 'Books',
    'marketplace.categories.health': 'Health & Beauty',
    'marketplace.categories.home': 'Home & Garden',
    'marketplace.categories.sports': 'Sports & Outdoors',
    'marketplace.categories.toys': 'Toys & Games',
    'marketplace.categories.automotive': 'Automotive',
    'marketplace.categories.art': 'Art & Collectibles',
    'marketplace.categories.music': 'Music',
    'marketplace.categories.other': 'Other',
    'marketplace.tabs.stores': 'Stores',
    'marketplace.tabs.listings': 'Listings',
    'marketplace.search.storesPlaceholder': 'Search stores...',
    'marketplace.search.listingsPlaceholder': 'Search listings...',
    'marketplace.search.locationPlaceholder': 'Enter location...',
    'marketplace.search.searching': 'Searching...',
    'marketplace.search.button': 'Search',
    'marketplace.sort.recent': 'Most Recent',
    'marketplace.sort.priceLow': 'Price: Low to High',
    'marketplace.sort.priceHigh': 'Price: High to Low',
    'marketplace.sort.popular': 'Most Popular',
    'marketplace.sort.name': 'Name',
    'marketplace.sort.rating': 'Highest rated',
    'marketplace.results.stores': 'Stores',
    'marketplace.results.listings': 'Listings',
    'marketplace.results.noStores': 'No stores found',
    'marketplace.results.noStoresHint': 'Try adjusting your search or filters',
    'marketplace.results.storesUnavailableTitle': 'Stores list is temporarily unavailable',
    'marketplace.results.storesUnavailableHint':
      'We could not load businesses right now. Try again in a moment or switch to the Listings tab.',
    'marketplace.results.storesRetry': 'Try again',
    'marketplace.results.loadingMoreStores': 'Loading more stores...',
    'marketplace.results.scrollMore': 'Scroll for more',
    'marketplace.results.showingAllStores': 'Showing all stores',
    'marketplace.results.loadingListings': 'Loading listings...',
    'marketplace.results.loadingListingsHint': 'Please wait while we fetch available listings',
    'marketplace.results.noListings': 'No listings found',
    'marketplace.results.noListingsHint': 'Try adjusting your search or filters',
    'marketplace.createListing.title': 'Create Listing',
    'marketplace.createListing.description': 'Create a new marketplace listing',
    'marketplace.createListing.form.title': 'Title',
    'marketplace.createListing.form.titlePlaceholder': 'Enter a listing title',
    'marketplace.createListing.form.category': 'Category',
    'marketplace.createListing.form.categoryPlaceholder': 'Select a category',
    'marketplace.createListing.form.condition': 'Condition',
    'marketplace.createListing.form.conditionPlaceholder': 'Select condition',
    'marketplace.createListing.form.price': 'Price',
    'marketplace.createListing.form.description': 'Description',
    'marketplace.createListing.form.descriptionPlaceholder': 'Describe your listing',
    'marketplace.createListing.form.images': 'Images',
    'marketplace.createListing.form.imagesPlaceholder': 'Upload product photos',
    'marketplace.createListing.form.imagesHint': 'Add clear images to improve visibility',
    'marketplace.createListing.form.tags': 'Tags',
    'marketplace.createListing.form.tagsPlaceholder': 'Add tags separated by commas',
    'marketplace.createListing.form.offerShipping': 'Offer shipping',
    'marketplace.createListing.form.creating': 'Creating...',
    'marketplace.createListing.form.submit': 'Create Listing',
  },
  es: {
    'marketplace.title': 'Mercado',
    'marketplace.subtitle': 'Descubre negocios locales y anuncios cerca de ti',
    'marketplace.filters.title': 'Filtros',
    'marketplace.filters.category': 'Categoría',
    'marketplace.filters.allCategories': 'Todas las Categorías',
    'marketplace.filters.locationRadius': 'Radio de Ubicación',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Mundial',
    'marketplace.filters.clear': 'Limpiar Filtros',
    'marketplace.categories.ecommerce': 'Comercio electrónico',
    'marketplace.categories.food_beverage': 'Alimentación y bebidas',
    'marketplace.categories.retail': 'Retail',
    'marketplace.categories.services': 'Servicios',
    'marketplace.categories.digital': 'Digital',
    'marketplace.categories.clothing': 'Ropa',
    'marketplace.categories.electronics': 'Electrónica',
    'marketplace.categories.books': 'Libros',
    'marketplace.categories.health': 'Salud y belleza',
    'marketplace.categories.home': 'Hogar y jardín',
    'marketplace.categories.sports': 'Deportes y aire libre',
    'marketplace.categories.toys': 'Juguetes y juegos',
    'marketplace.categories.automotive': 'Automoción',
    'marketplace.categories.art': 'Arte y coleccionables',
    'marketplace.categories.music': 'Música',
    'marketplace.categories.other': 'Otro',
    'marketplace.tabs.stores': 'Tiendas',
    'marketplace.tabs.listings': 'Anuncios',
    'marketplace.search.storesPlaceholder': 'Buscar tiendas...',
    'marketplace.search.listingsPlaceholder': 'Buscar anuncios...',
    'marketplace.search.locationPlaceholder': 'Ingresar ubicación...',
    'marketplace.search.searching': 'Buscando...',
    'marketplace.search.button': 'Buscar',
    'marketplace.sort.recent': 'Más Recientes',
    'marketplace.sort.priceLow': 'Precio: Menor a Mayor',
    'marketplace.sort.priceHigh': 'Precio: Mayor a Menor',
    'marketplace.sort.popular': 'Más Populares',
    'marketplace.results.stores': 'Tiendas',
    'marketplace.results.listings': 'Anuncios',
    'marketplace.results.noStores': 'No se encontraron tiendas',
    'marketplace.results.noStoresHint': 'Intenta ajustar tu búsqueda o filtros',
    'marketplace.results.storesUnavailableTitle': 'La lista de tiendas no está disponible por ahora',
    'marketplace.results.storesUnavailableHint':
      'No pudimos cargar negocios en este momento. Vuelve a intentarlo o revisa la pestaña Anuncios.',
    'marketplace.results.storesRetry': 'Volver a intentar',
    'marketplace.results.loadingMoreStores': 'Cargando más tiendas...',
    'marketplace.results.scrollMore': 'Desplázate para más',
    'marketplace.results.showingAllStores': 'Mostrando todas las tiendas',
    'marketplace.results.loadingListings': 'Cargando anuncios...',
    'marketplace.results.loadingListingsHint': 'Por favor espera mientras obtenemos los anuncios disponibles',
    'marketplace.results.noListings': 'No se encontraron anuncios',
    'marketplace.results.noListingsHint': 'Intenta ajustar tu búsqueda o filtros',
  },
  fr: {
    'marketplace.title': 'Marché',
    'marketplace.subtitle': 'Découvrez les entreprises locales et les annonces près de chez vous',
    'marketplace.filters.title': 'Filtres',
    'marketplace.filters.category': 'Catégorie',
    'marketplace.filters.allCategories': 'Toutes les Catégories',
    'marketplace.filters.locationRadius': 'Rayon de Localisation',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Mondial',
    'marketplace.filters.clear': 'Effacer les Filtres',
    'marketplace.categories.ecommerce': 'E-commerce',
    'marketplace.categories.food_beverage': 'Alimentation et boissons',
    'marketplace.categories.retail': 'Commerce de détail',
    'marketplace.categories.services': 'Services',
    'marketplace.categories.digital': 'Numérique',
    'marketplace.categories.clothing': 'Vêtements',
    'marketplace.categories.electronics': 'Électronique',
    'marketplace.categories.books': 'Livres',
    'marketplace.categories.health': 'Santé et beauté',
    'marketplace.categories.home': 'Maison et jardin',
    'marketplace.categories.sports': 'Sports et plein air',
    'marketplace.categories.toys': 'Jouets et jeux',
    'marketplace.categories.automotive': 'Automobile',
    'marketplace.categories.art': 'Art et collections',
    'marketplace.categories.music': 'Musique',
    'marketplace.categories.other': 'Autre',
    'marketplace.tabs.stores': 'Magasins',
    'marketplace.tabs.listings': 'Annonces',
    'marketplace.search.storesPlaceholder': 'Rechercher des magasins...',
    'marketplace.search.listingsPlaceholder': 'Rechercher des annonces...',
    'marketplace.search.locationPlaceholder': 'Entrer la localisation...',
    'marketplace.search.searching': 'Recherche...',
    'marketplace.search.button': 'Rechercher',
    'marketplace.sort.recent': 'Plus Récent',
    'marketplace.sort.priceLow': 'Prix: Croissant',
    'marketplace.sort.priceHigh': 'Prix: Décroissant',
    'marketplace.sort.popular': 'Plus Populaire',
    'marketplace.results.stores': 'Magasins',
    'marketplace.results.listings': 'Annonces',
    'marketplace.results.noStores': 'Aucun magasin trouvé',
    'marketplace.results.noStoresHint': 'Essayez d\'ajuster votre recherche ou vos filtres',
    'marketplace.results.storesUnavailableTitle': 'La liste des magasins est temporairement indisponible',
    'marketplace.results.storesUnavailableHint':
      'Impossible de charger les commerces pour le moment. Réessayez ou consultez l’onglet Annonces.',
    'marketplace.results.storesRetry': 'Réessayer',
    'marketplace.results.loadingMoreStores': 'Chargement de plus de magasins...',
    'marketplace.results.scrollMore': 'Faites défiler pour plus',
    'marketplace.results.showingAllStores': 'Affichage de tous les magasins',
    'marketplace.results.loadingListings': 'Chargement des annonces...',
    'marketplace.results.loadingListingsHint': 'Veuillez patienter pendant que nous récupérons les annonces disponibles',
    'marketplace.results.noListings': 'Aucune annonce trouvée',
    'marketplace.results.noListingsHint': 'Essayez d\'ajuster votre recherche ou vos filtres',
  },
  sq: {
    'marketplace.title': 'Tregu',
    'marketplace.subtitle': 'Zbuloni bizneset lokale dhe listat pranë teje',
    'marketplace.filters.title': 'Filtrat',
    'marketplace.filters.category': 'Kategoria',
    'marketplace.filters.allCategories': 'Të Gjitha Kategoritë',
    'marketplace.filters.locationRadius': 'Rrezja e Vendndodhjes',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Në Mbarë Botën',
    'marketplace.filters.clear': 'Pastro Filtrat',
    'marketplace.categories.ecommerce': 'E-tregti',
    'marketplace.categories.food_beverage': 'Ushqim dhe pije',
    'marketplace.categories.retail': 'Shitje me pakicë',
    'marketplace.categories.services': 'Shërbime',
    'marketplace.categories.digital': 'Dixhital',
    'marketplace.categories.clothing': 'Veshje',
    'marketplace.categories.electronics': 'Elektronikë',
    'marketplace.categories.books': 'Libra',
    'marketplace.categories.health': 'Shëndet dhe bukuri',
    'marketplace.categories.home': 'Shtëpi dhe kopsht',
    'marketplace.categories.sports': 'Sporte dhe natyrë',
    'marketplace.categories.toys': 'Lodra dhe lojëra',
    'marketplace.categories.automotive': 'Automjete',
    'marketplace.categories.art': 'Art dhe koleksione',
    'marketplace.categories.music': 'Muzikë',
    'marketplace.categories.other': 'Tjetër',
    'marketplace.tabs.stores': 'Dyqane',
    'marketplace.tabs.listings': 'Listat',
    'marketplace.search.storesPlaceholder': 'Kërko dyqane...',
    'marketplace.search.listingsPlaceholder': 'Kërko lista...',
    'marketplace.search.locationPlaceholder': 'Shkruaj vendndodhjen...',
    'marketplace.search.searching': 'Duke kërkuar...',
    'marketplace.search.button': 'Kërko',
    'marketplace.sort.recent': 'Më të Fundit',
    'marketplace.sort.priceLow': 'Çmimi: Nga Më i Ulët te Më i Lartë',
    'marketplace.sort.priceHigh': 'Çmimi: Nga Më i Lartë te Më i Ulët',
    'marketplace.sort.popular': 'Më të Popullarizuara',
    'marketplace.results.stores': 'Dyqane',
    'marketplace.results.listings': 'Listat',
    'marketplace.results.noStores': 'Nuk u gjetën dyqane',
    'marketplace.results.noStoresHint': 'Provoni të rregulloni kërkimin ose filtrat tuaj',
    'marketplace.results.storesUnavailableTitle': 'Lista e dyqaneve është përkohësisht e padisponueshme',
    'marketplace.results.storesUnavailableHint':
      'Nuk mundëm të ngarkojmë bizneset tani. Provoni përsëri ose kaloni te skeda e listave.',
    'marketplace.results.storesRetry': 'Provo përsëri',
    'marketplace.results.loadingMoreStores': 'Duke ngarkuar më shumë dyqane...',
    'marketplace.results.scrollMore': 'Lëviz për më shumë',
    'marketplace.results.showingAllStores': 'Duke shfaqur të gjitha dyqanet',
    'marketplace.results.loadingListings': 'Duke ngarkuar listat...',
    'marketplace.results.loadingListingsHint': 'Ju lutemi prisni ndërsa marrim listat e disponueshme',
    'marketplace.results.noListings': 'Nuk u gjetën lista',
    'marketplace.results.noListingsHint': 'Provoni të rregulloni kërkimin ose filtrat tuaj',
  },
  ru: {
    'marketplace.title': 'Торговая Площадка',
    'marketplace.subtitle': 'Откройте для себя местные предприятия и объявления рядом с вами',
    'marketplace.filters.title': 'Фильтры',
    'marketplace.filters.category': 'Категория',
    'marketplace.filters.allCategories': 'Все Категории',
    'marketplace.filters.locationRadius': 'Радиус Местоположения',
    'marketplace.filters.radius.10': '10 км',
    'marketplace.filters.radius.25': '25 км',
    'marketplace.filters.radius.50': '50 км',
    'marketplace.filters.radius.100': '100 км',
    'marketplace.filters.radius.250': '250 км',
    'marketplace.filters.radius.500': '500 км',
    'marketplace.filters.radius.worldwide': 'По Всему Миру',
    'marketplace.filters.clear': 'Очистить Фильтры',
    'marketplace.categories.ecommerce': 'Электронная коммерция',
    'marketplace.categories.food_beverage': 'Еда и напитки',
    'marketplace.categories.retail': 'Розничная торговля',
    'marketplace.categories.services': 'Услуги',
    'marketplace.categories.digital': 'Цифровые товары',
    'marketplace.categories.clothing': 'Одежда',
    'marketplace.categories.electronics': 'Электроника',
    'marketplace.categories.books': 'Книги',
    'marketplace.categories.health': 'Здоровье и красота',
    'marketplace.categories.home': 'Дом и сад',
    'marketplace.categories.sports': 'Спорт и отдых',
    'marketplace.categories.toys': 'Игрушки и игры',
    'marketplace.categories.automotive': 'Авто',
    'marketplace.categories.art': 'Искусство и коллекции',
    'marketplace.categories.music': 'Музыка',
    'marketplace.categories.other': 'Другое',
    'marketplace.tabs.stores': 'Магазины',
    'marketplace.tabs.listings': 'Объявления',
    'marketplace.search.storesPlaceholder': 'Поиск магазинов...',
    'marketplace.search.listingsPlaceholder': 'Поиск объявлений...',
    'marketplace.search.locationPlaceholder': 'Введите местоположение...',
    'marketplace.search.searching': 'Поиск...',
    'marketplace.search.button': 'Поиск',
    'marketplace.sort.recent': 'Самые Новые',
    'marketplace.sort.priceLow': 'Цена: По Возрастанию',
    'marketplace.sort.priceHigh': 'Цена: По Убыванию',
    'marketplace.sort.popular': 'Самые Популярные',
    'marketplace.results.stores': 'Магазины',
    'marketplace.results.listings': 'Объявления',
    'marketplace.results.noStores': 'Магазины не найдены',
    'marketplace.results.noStoresHint': 'Попробуйте изменить поиск или фильтры',
    'marketplace.results.storesUnavailableTitle': 'Список магазинов временно недоступен',
    'marketplace.results.storesUnavailableHint':
      'Не удалось загрузить данные. Попробуйте снова или откройте вкладку «Объявления».',
    'marketplace.results.storesRetry': 'Повторить',
    'marketplace.results.loadingMoreStores': 'Загрузка дополнительных магазинов...',
    'marketplace.results.scrollMore': 'Прокрутите для большего',
    'marketplace.results.showingAllStores': 'Показаны все магазины',
    'marketplace.results.loadingListings': 'Загрузка объявлений...',
    'marketplace.results.loadingListingsHint': 'Пожалуйста, подождите, пока мы получим доступные объявления',
    'marketplace.results.noListings': 'Объявления не найдены',
    'marketplace.results.noListingsHint': 'Попробуйте изменить поиск или фильтры',
  },
  pt: {
    'marketplace.title': 'Mercado',
    'marketplace.subtitle': 'Descubra negócios locais e anúncios perto de você',
    'marketplace.filters.title': 'Filtros',
    'marketplace.filters.category': 'Categoria',
    'marketplace.filters.allCategories': 'Todas as Categorias',
    'marketplace.filters.locationRadius': 'Raio de Localização',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Mundial',
    'marketplace.filters.clear': 'Limpar Filtros',
    'marketplace.categories.ecommerce': 'Comércio eletrônico',
    'marketplace.categories.food_beverage': 'Alimentos e bebidas',
    'marketplace.categories.retail': 'Varejo',
    'marketplace.categories.services': 'Serviços',
    'marketplace.categories.digital': 'Digital',
    'marketplace.categories.clothing': 'Roupas',
    'marketplace.categories.electronics': 'Eletrônicos',
    'marketplace.categories.books': 'Livros',
    'marketplace.categories.health': 'Saúde e beleza',
    'marketplace.categories.home': 'Casa e jardim',
    'marketplace.categories.sports': 'Esportes e ar livre',
    'marketplace.categories.toys': 'Brinquedos e jogos',
    'marketplace.categories.automotive': 'Automotivo',
    'marketplace.categories.art': 'Arte e colecionáveis',
    'marketplace.categories.music': 'Música',
    'marketplace.categories.other': 'Outro',
    'marketplace.tabs.stores': 'Lojas',
    'marketplace.tabs.listings': 'Anúncios',
    'marketplace.search.storesPlaceholder': 'Buscar lojas...',
    'marketplace.search.listingsPlaceholder': 'Buscar anúncios...',
    'marketplace.search.locationPlaceholder': 'Digite a localização...',
    'marketplace.search.searching': 'Buscando...',
    'marketplace.search.button': 'Buscar',
    'marketplace.sort.recent': 'Mais Recentes',
    'marketplace.sort.priceLow': 'Preço: Menor para Maior',
    'marketplace.sort.priceHigh': 'Preço: Maior para Menor',
    'marketplace.sort.popular': 'Mais Populares',
    'marketplace.results.stores': 'Lojas',
    'marketplace.results.listings': 'Anúncios',
    'marketplace.results.noStores': 'Nenhuma loja encontrada',
    'marketplace.results.noStoresHint': 'Tente ajustar sua busca ou filtros',
    'marketplace.results.storesUnavailableTitle': 'A lista de lojas está temporariamente indisponível',
    'marketplace.results.storesUnavailableHint':
      'Não foi possível carregar as lojas agora. Tente de novo ou use a aba Anúncios.',
    'marketplace.results.storesRetry': 'Tentar novamente',
    'marketplace.results.loadingMoreStores': 'Carregando mais lojas...',
    'marketplace.results.scrollMore': 'Role para mais',
    'marketplace.results.showingAllStores': 'Mostrando todas as lojas',
    'marketplace.results.loadingListings': 'Carregando anúncios...',
    'marketplace.results.loadingListingsHint': 'Por favor aguarde enquanto buscamos os anúncios disponíveis',
    'marketplace.results.noListings': 'Nenhum anúncio encontrado',
    'marketplace.results.noListingsHint': 'Tente ajustar sua busca ou filtros',
  },
  el: {
    'marketplace.title': 'Αγορά',
    'marketplace.subtitle': 'Ανακαλύψτε τοπικές επιχειρήσεις και καταχωρήσεις κοντά σας',
    'marketplace.filters.title': 'Φίλτρα',
    'marketplace.filters.category': 'Κατηγορία',
    'marketplace.filters.allCategories': 'Όλες οι Κατηγορίες',
    'marketplace.filters.locationRadius': 'Ακτίνα Τοποθεσίας',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Παγκόσμια',
    'marketplace.filters.clear': 'Καθαρισμός Φίλτρων',
    'marketplace.categories.ecommerce': 'Ηλεκτρονικό εμπόριο',
    'marketplace.categories.food_beverage': 'Τρόφιμα και ποτά',
    'marketplace.categories.retail': 'Λιανική',
    'marketplace.categories.services': 'Υπηρεσίες',
    'marketplace.categories.digital': 'Ψηφιακά',
    'marketplace.categories.clothing': 'Ένδυση',
    'marketplace.categories.electronics': 'Ηλεκτρονικά',
    'marketplace.categories.books': 'Βιβλία',
    'marketplace.categories.health': 'Υγεία και ομορφιά',
    'marketplace.categories.home': 'Σπίτι και κήπος',
    'marketplace.categories.sports': 'Αθλητισμός και ύπαιθρος',
    'marketplace.categories.toys': 'Παιχνίδια',
    'marketplace.categories.automotive': 'Αυτοκίνητα',
    'marketplace.categories.art': 'Τέχνη και συλλεκτικά',
    'marketplace.categories.music': 'Μουσική',
    'marketplace.categories.other': 'Άλλο',
    'marketplace.tabs.stores': 'Καταστήματα',
    'marketplace.tabs.listings': 'Καταχωρήσεις',
    'marketplace.search.storesPlaceholder': 'Αναζήτηση καταστημάτων...',
    'marketplace.search.listingsPlaceholder': 'Αναζήτηση καταχωρήσεων...',
    'marketplace.search.locationPlaceholder': 'Εισαγάγετε τοποθεσία...',
    'marketplace.search.searching': 'Αναζήτηση...',
    'marketplace.search.button': 'Αναζήτηση',
    'marketplace.sort.recent': 'Πιο Πρόσφατα',
    'marketplace.sort.priceLow': 'Τιμή: Χαμηλή προς Υψηλή',
    'marketplace.sort.priceHigh': 'Τιμή: Υψηλή προς Χαμηλή',
    'marketplace.sort.popular': 'Πιο Δημοφιλή',
    'marketplace.results.stores': 'Καταστήματα',
    'marketplace.results.listings': 'Καταχωρήσεις',
    'marketplace.results.noStores': 'Δεν βρέθηκαν καταστήματα',
    'marketplace.results.noStoresHint': 'Δοκιμάστε να προσαρμόσετε την αναζήτηση ή τα φίλτρα σας',
    'marketplace.results.storesUnavailableTitle': 'Η λίστα καταστημάτων δεν είναι διαθέσιμη προσωρινά',
    'marketplace.results.storesUnavailableHint':
      'Δεν ήταν δυνατή η φόρτωση καταστημάτων. Δοκιμάστε ξανά ή ανοίξτε την καρτέλα Καταχωρήσεις.',
    'marketplace.results.storesRetry': 'Δοκιμάστε ξανά',
    'marketplace.results.loadingMoreStores': 'Φόρτωση περισσότερων καταστημάτων...',
    'marketplace.results.scrollMore': 'Κυλήστε για περισσότερα',
    'marketplace.results.showingAllStores': 'Εμφάνιση όλων των καταστημάτων',
    'marketplace.results.loadingListings': 'Φόρτωση καταχωρήσεων...',
    'marketplace.results.loadingListingsHint': 'Παρακαλώ περιμένετε ενώ ανακτούμε τις διαθέσιμες καταχωρήσεις',
    'marketplace.results.noListings': 'Δεν βρέθηκαν καταχωρήσεις',
    'marketplace.results.noListingsHint': 'Δοκιμάστε να προσαρμόσετε την αναζήτηση ή τα φίλτρα σας',
  },
  de: {
    'marketplace.title': 'Marktplatz',
    'marketplace.subtitle': 'Entdecken Sie lokale Unternehmen und Anzeigen in Ihrer Nähe',
    'marketplace.filters.title': 'Filter',
    'marketplace.filters.category': 'Kategorie',
    'marketplace.filters.allCategories': 'Alle Kategorien',
    'marketplace.filters.locationRadius': 'Standortradius',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Weltweit',
    'marketplace.filters.clear': 'Filter Löschen',
    'marketplace.categories.ecommerce': 'E-Commerce',
    'marketplace.categories.food_beverage': 'Essen & Trinken',
    'marketplace.categories.retail': 'Einzelhandel',
    'marketplace.categories.services': 'Dienstleistungen',
    'marketplace.categories.digital': 'Digital',
    'marketplace.categories.clothing': 'Bekleidung',
    'marketplace.categories.electronics': 'Elektronik',
    'marketplace.categories.books': 'Bücher',
    'marketplace.categories.health': 'Gesundheit & Schönheit',
    'marketplace.categories.home': 'Haus & Garten',
    'marketplace.categories.sports': 'Sport & Outdoor',
    'marketplace.categories.toys': 'Spielzeug & Spiele',
    'marketplace.categories.automotive': 'Automobil',
    'marketplace.categories.art': 'Kunst & Sammlerstücke',
    'marketplace.categories.music': 'Musik',
    'marketplace.categories.other': 'Sonstiges',
    'marketplace.tabs.stores': 'Geschäfte',
    'marketplace.tabs.listings': 'Anzeigen',
    'marketplace.search.storesPlaceholder': 'Geschäfte suchen...',
    'marketplace.search.listingsPlaceholder': 'Anzeigen suchen...',
    'marketplace.search.locationPlaceholder': 'Standort eingeben...',
    'marketplace.search.searching': 'Suche...',
    'marketplace.search.button': 'Suchen',
    'marketplace.sort.recent': 'Neueste',
    'marketplace.sort.priceLow': 'Preis: Niedrig zu Hoch',
    'marketplace.sort.priceHigh': 'Preis: Hoch zu Niedrig',
    'marketplace.sort.popular': 'Beliebteste',
    'marketplace.results.stores': 'Geschäfte',
    'marketplace.results.listings': 'Anzeigen',
    'marketplace.results.noStores': 'Keine Geschäfte gefunden',
    'marketplace.results.noStoresHint': 'Versuchen Sie, Ihre Suche oder Filter anzupassen',
    'marketplace.results.storesUnavailableTitle': 'Die Geschäftsliste ist vorübergehend nicht verfügbar',
    'marketplace.results.storesUnavailableHint':
      'Geschäfte konnten gerade nicht geladen werden. Bitte erneut versuchen oder den Tab Anzeigen öffnen.',
    'marketplace.results.storesRetry': 'Erneut versuchen',
    'marketplace.results.loadingMoreStores': 'Lade weitere Geschäfte...',
    'marketplace.results.scrollMore': 'Scrollen Sie für mehr',
    'marketplace.results.showingAllStores': 'Zeige alle Geschäfte',
    'marketplace.results.loadingListings': 'Lade Anzeigen...',
    'marketplace.results.loadingListingsHint': 'Bitte warten Sie, während wir die verfügbaren Anzeigen abrufen',
    'marketplace.results.noListings': 'Keine Anzeigen gefunden',
    'marketplace.results.noListingsHint': 'Versuchen Sie, Ihre Suche oder Filter anzupassen',
  },
  ro: {
    'marketplace.title': 'Piață',
    'marketplace.subtitle': 'Descoperă afacerile locale și anunțurile din apropierea ta',
    'marketplace.filters.title': 'Filtre',
    'marketplace.filters.category': 'Categorie',
    'marketplace.filters.allCategories': 'Toate Categoriile',
    'marketplace.filters.locationRadius': 'Raza Locației',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'La Nivel Mondial',
    'marketplace.filters.clear': 'Șterge Filtrele',
    'marketplace.categories.ecommerce': 'Comerț electronic',
    'marketplace.categories.food_beverage': 'Alimente și băuturi',
    'marketplace.categories.retail': 'Retail',
    'marketplace.categories.services': 'Servicii',
    'marketplace.categories.digital': 'Digital',
    'marketplace.categories.clothing': 'Îmbrăcăminte',
    'marketplace.categories.electronics': 'Electronice',
    'marketplace.categories.books': 'Cărți',
    'marketplace.categories.health': 'Sănătate și frumusețe',
    'marketplace.categories.home': 'Casă și grădină',
    'marketplace.categories.sports': 'Sport și aer liber',
    'marketplace.categories.toys': 'Jucării și jocuri',
    'marketplace.categories.automotive': 'Auto',
    'marketplace.categories.art': 'Artă și colecții',
    'marketplace.categories.music': 'Muzică',
    'marketplace.categories.other': 'Altele',
    'marketplace.tabs.stores': 'Magazine',
    'marketplace.tabs.listings': 'Anunțuri',
    'marketplace.search.storesPlaceholder': 'Caută magazine...',
    'marketplace.search.listingsPlaceholder': 'Caută anunțuri...',
    'marketplace.search.locationPlaceholder': 'Introdu locația...',
    'marketplace.search.searching': 'Căutare...',
    'marketplace.search.button': 'Caută',
    'marketplace.sort.recent': 'Cele Mai Recente',
    'marketplace.sort.priceLow': 'Preț: De la Mic la Mare',
    'marketplace.sort.priceHigh': 'Preț: De la Mare la Mic',
    'marketplace.sort.popular': 'Cele Mai Populare',
    'marketplace.results.stores': 'Magazine',
    'marketplace.results.listings': 'Anunțuri',
    'marketplace.results.noStores': 'Nu s-au găsit magazine',
    'marketplace.results.noStoresHint': 'Încearcă să ajustezi căutarea sau filtrele',
    'marketplace.results.storesUnavailableTitle': 'Lista de magazine este temporar indisponibilă',
    'marketplace.results.storesUnavailableHint':
      'Nu am putut încărca magazinele acum. Încearcă din nou sau deschide fila Anunțuri.',
    'marketplace.results.storesRetry': 'Încearcă din nou',
    'marketplace.results.loadingMoreStores': 'Se încarcă mai multe magazine...',
    'marketplace.results.scrollMore': 'Derulează pentru mai mult',
    'marketplace.results.showingAllStores': 'Se afișează toate magazinele',
    'marketplace.results.loadingListings': 'Se încarcă anunțurile...',
    'marketplace.results.loadingListingsHint': 'Te rugăm să aștepți în timp ce preluăm anunțurile disponibile',
    'marketplace.results.noListings': 'Nu s-au găsit anunțuri',
    'marketplace.results.noListingsHint': 'Încearcă să ajustezi căutarea sau filtrele',
  },
  sr: {
    'marketplace.title': 'Тржиште',
    'marketplace.subtitle': 'Откријте локалне послове и огласе у вашој близини',
    'marketplace.filters.title': 'Филтери',
    'marketplace.filters.category': 'Категорија',
    'marketplace.filters.allCategories': 'Све Категорије',
    'marketplace.filters.locationRadius': 'Радијус Локације',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Широм Света',
    'marketplace.filters.clear': 'Обриши Филтере',
    'marketplace.categories.ecommerce': 'Е-трговина',
    'marketplace.categories.food_beverage': 'Храна и пића',
    'marketplace.categories.retail': 'Малопродаја',
    'marketplace.categories.services': 'Услуге',
    'marketplace.categories.digital': 'Дигитално',
    'marketplace.categories.clothing': 'Одећа',
    'marketplace.categories.electronics': 'Електроника',
    'marketplace.categories.books': 'Књиге',
    'marketplace.categories.health': 'Здравље и лепота',
    'marketplace.categories.home': 'Дом и башта',
    'marketplace.categories.sports': 'Спорт и природа',
    'marketplace.categories.toys': 'Играчке и игре',
    'marketplace.categories.automotive': 'Ауто',
    'marketplace.categories.art': 'Уметност и колекције',
    'marketplace.categories.music': 'Музика',
    'marketplace.categories.other': 'Остало',
    'marketplace.tabs.stores': 'Продавнице',
    'marketplace.tabs.listings': 'Огласи',
    'marketplace.search.storesPlaceholder': 'Претражи продавнице...',
    'marketplace.search.listingsPlaceholder': 'Претражи огласе...',
    'marketplace.search.locationPlaceholder': 'Унеси локацију...',
    'marketplace.search.searching': 'Претрага...',
    'marketplace.search.button': 'Претражи',
    'marketplace.sort.recent': 'Најновије',
    'marketplace.sort.priceLow': 'Цена: Од Ниске ка Високој',
    'marketplace.sort.priceHigh': 'Цена: Од Високе ка Ниској',
    'marketplace.sort.popular': 'Најпопуларније',
    'marketplace.results.stores': 'Продавнице',
    'marketplace.results.listings': 'Огласи',
    'marketplace.results.noStores': 'Нису пронађене продавнице',
    'marketplace.results.noStoresHint': 'Покушајте да подесите претрагу или филтере',
    'marketplace.results.storesUnavailableTitle': 'Листа продавница привремено није доступна',
    'marketplace.results.storesUnavailableHint':
      'Тренутно не можемо да учитамо продавнице. Покушајте поново или отворите картицу Огласи.',
    'marketplace.results.storesRetry': 'Покушај поново',
    'marketplace.results.loadingMoreStores': 'Учитавање више продавница...',
    'marketplace.results.scrollMore': 'Скролујте за више',
    'marketplace.results.showingAllStores': 'Приказују се све продавнице',
    'marketplace.results.loadingListings': 'Учитавање огласа...',
    'marketplace.results.loadingListingsHint': 'Молимо сачекајте док преузимамо доступне огласе',
    'marketplace.results.noListings': 'Нису пронађени огласи',
    'marketplace.results.noListingsHint': 'Покушајте да подесите претрагу или филтере',
  },
  pl: {
    'marketplace.title': 'Rynek',
    'marketplace.subtitle': 'Odkryj lokalne firmy i ogłoszenia w pobliżu',
    'marketplace.filters.title': 'Filtry',
    'marketplace.filters.category': 'Kategoria',
    'marketplace.filters.allCategories': 'Wszystkie Kategorie',
    'marketplace.filters.locationRadius': 'Promień Lokalizacji',
    'marketplace.filters.radius.10': '10 km',
    'marketplace.filters.radius.25': '25 km',
    'marketplace.filters.radius.50': '50 km',
    'marketplace.filters.radius.100': '100 km',
    'marketplace.filters.radius.250': '250 km',
    'marketplace.filters.radius.500': '500 km',
    'marketplace.filters.radius.worldwide': 'Na Całym Świecie',
    'marketplace.filters.clear': 'Wyczyść Filtry',
    'marketplace.categories.ecommerce': 'E-commerce',
    'marketplace.categories.food_beverage': 'Żywność i napoje',
    'marketplace.categories.retail': 'Handel detaliczny',
    'marketplace.categories.services': 'Usługi',
    'marketplace.categories.digital': 'Cyfrowe',
    'marketplace.categories.clothing': 'Odzież',
    'marketplace.categories.electronics': 'Elektronika',
    'marketplace.categories.books': 'Książki',
    'marketplace.categories.health': 'Zdrowie i uroda',
    'marketplace.categories.home': 'Dom i ogród',
    'marketplace.categories.sports': 'Sport i outdoor',
    'marketplace.categories.toys': 'Zabawki i gry',
    'marketplace.categories.automotive': 'Motoryzacja',
    'marketplace.categories.art': 'Sztuka i kolekcje',
    'marketplace.categories.music': 'Muzyka',
    'marketplace.categories.other': 'Inne',
    'marketplace.tabs.stores': 'Sklepy',
    'marketplace.tabs.listings': 'Ogłoszenia',
    'marketplace.search.storesPlaceholder': 'Szukaj sklepów...',
    'marketplace.search.listingsPlaceholder': 'Szukaj ogłoszeń...',
    'marketplace.search.locationPlaceholder': 'Wprowadź lokalizację...',
    'marketplace.search.searching': 'Szukanie...',
    'marketplace.search.button': 'Szukaj',
    'marketplace.sort.recent': 'Najnowsze',
    'marketplace.sort.priceLow': 'Cena: Od Najniższej',
    'marketplace.sort.priceHigh': 'Cena: Od Najwyższej',
    'marketplace.sort.popular': 'Najpopularniejsze',
    'marketplace.results.stores': 'Sklepy',
    'marketplace.results.listings': 'Ogłoszenia',
    'marketplace.results.noStores': 'Nie znaleziono sklepów',
    'marketplace.results.noStoresHint': 'Spróbuj dostosować wyszukiwanie lub filtry',
    'marketplace.results.storesUnavailableTitle': 'Lista sklepów jest tymczasowo niedostępna',
    'marketplace.results.storesUnavailableHint':
      'Nie udało się wczytać sklepów. Spróbuj ponownie lub przejdź do zakładki Ogłoszenia.',
    'marketplace.results.storesRetry': 'Spróbuj ponownie',
    'marketplace.results.loadingMoreStores': 'Ładowanie więcej sklepów...',
    'marketplace.results.scrollMore': 'Przewiń, aby zobaczyć więcej',
    'marketplace.results.showingAllStores': 'Wyświetlanie wszystkich sklepów',
    'marketplace.results.loadingListings': 'Ładowanie ogłoszeń...',
    'marketplace.results.loadingListingsHint': 'Proszę czekać, podczas gdy pobieramy dostępne ogłoszenia',
    'marketplace.results.noListings': 'Nie znaleziono ogłoszeń',
    'marketplace.results.noListingsHint': 'Spróbuj dostosować wyszukiwanie lub filtry',
  },
};
